import {useEffect} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {calculateRemSize, mb, p} from "@pg-design/helpers-css-strings";
import {IRange} from "@pg-design/range-module";
import {SliderWithRangeControlled} from "@pg-design/rhf-components-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";
import {SearchFiltersRooms} from "../../../search/components/filters/SearchFiltersRooms";
import {FilterBudget} from "../../../search/components/generic_filters/FilterBudget";
import {usePriceRanges} from "../../../search/hooks/use_price_ranges";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setForYouCriteria} from "../../state/for_you_modal_slice";
import {ForYouCriteriaGtmEvent, ForYouFormDisplayGtmEvent} from "../../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../../types/ForYouDisplayActions";
import {ForYouEventType} from "../../types/ForYouEventType";
import {ForYouFormValuesType} from "../../types/IForYouForm";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    onChange?: (name: string, value: ForYouFormValuesType) => void;
}

export const ForYouCriteriaForm = (props: IProps) => {
    const mainRegion = useAppSelector((state) => state.forYouModal.mainRegionName);
    const dispatch = useAppDispatch();
    const budgetFieldsNames = {
        radio: `forYou_${BudgetFieldsNames.RADIO}`,
        credit: `forYou_${BudgetFieldsNames.CREDIT}`,
        total: `forYou_${BudgetFieldsNames.TOTAL}`
    };
    const {isMobile} = useUserDevice();
    const rooms = useWatch({name: "rooms"});
    const area = useWatch({name: "area"});
    const budget = useWatch({name: budgetFieldsNames.total});
    const instalment = useWatch({name: budgetFieldsNames.credit});
    const radioWatcher = useWatch({name: budgetFieldsNames.total});
    const maxArea = 300;
    const {maxPrice} = usePriceRanges();

    useEffect(() => {
        ForYouFormDisplayGtmEvent({event: ForYouEventType.CRITERIA, action: ForYouDisplayActions.OPEN, region: mainRegion});
    }, []);

    const onSubmit = () => {
        const roomsString = rooms.lower === rooms.upper ? rooms.lower.toString() : `${rooms.lower} - ${rooms.upper}`;
        const areaString = `${area.lower} - ${area.upper}`;
        const budgetString = radioWatcher === "total" ? budget.toString() : "";
        const instalmentString = radioWatcher === "monthly" ? instalment.toString() : "";
        dispatch(setForYouCriteria({rooms, area, ...(radioWatcher === "total" ? {budget} : {instalment})}));
        ForYouCriteriaGtmEvent({rooms: roomsString, area: areaString, budget: budgetString, instalment: instalmentString});
        props.onNextStep();
    };

    const setValue = (fieldName: string, value: IRange<number | "">) => {
        props.onChange?.(fieldName, value);
    };

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={formStyle}>
            <div css={filedWrapper}>
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Pokoje
                </Text>

                <SearchFiltersRooms toggleDropdown={() => null} clearField={() => null} name="rooms" value={rooms} showFooter={false} onChange={setValue} />
            </div>

            <div css={filedWrapper}>
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Powierzchnia mieszkania
                </Text>

                <SliderWithRangeControlled
                    name="area"
                    min={0}
                    max={maxArea}
                    step={1}
                    inputsRightElement={
                        <span>
                            m<sup>2</sup>
                        </span>
                    }
                />
            </div>

            <div css={filedWrapper}>
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Budżet
                </Text>

                <FilterBudget
                    radioGroupClassName="radioGroupStyles"
                    radioClassName="radiosStyles"
                    inputVariant={isMobile ? "column" : "row"}
                    fieldNames={budgetFieldsNames}
                    maxPrice={maxPrice}
                />
            </div>

            <ForYouModalButton isDisabled={area.lower > area.upper || area.upper < area.lower || area.upper > maxArea} showStep />
        </form>
    );
};

const formStyle = css`
    width: 100%;
    background-color: #fff;
    ${p(3, 1.5, 0, 1.5)};

    .radiosStyles {
        flex: 0;
        min-width: 160px;
    }

    .radioGroupStyles {
        ${mb(0)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            ${mb(2)};
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(4, 5, 4, 5)};
        height: 100%;
        background-color: ${getThemeVariable("colors.gray.100")};
    }

    .slider-with-range-slider-wrapper {
        flex: 1;
        width: 100%;
    }

    .slider-with-range-range-wrapper {
        flex: 1;
        width: 100%;

        @media (min-width: 1024px) {
            max-width: 40%;
        }
    }
`;

const filedWrapper = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${calculateRemSize(1)};
    ${mb(5)};
`;
import {useEffect} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {calculateRemSize, mb, p} from "@pg-design/helpers-css-strings";
import {IRange} from "@pg-design/range-module";
import {SliderWithRangeControlled} from "@pg-design/rhf-components-module";
import {getThemeBreakpoint, getThemeVariable} from "@pg-design/styles-strings";
import {Text} from "@pg-design/text-module";
import {useUserDevice} from "@pg-mono/user-device";

import {BudgetFieldsNames} from "../../../real_estate/types/BudgetFieldsNames";
import {SearchFiltersRooms} from "../../../search/components/filters/SearchFiltersRooms";
import {FilterBudget} from "../../../search/components/generic_filters/FilterBudget";
import {usePriceRanges} from "../../../search/hooks/use_price_ranges";
import {useAppDispatch, useAppSelector} from "../../../store/hooks";
import {setForYouCriteria} from "../../state/for_you_modal_slice";
import {ForYouCriteriaGtmEvent, ForYouFormDisplayGtmEvent} from "../../tracking/for_you_forms_gtm_events";
import {ForYouDisplayActions} from "../../types/ForYouDisplayActions";
import {ForYouEventType} from "../../types/ForYouEventType";
import {ForYouFormValuesType} from "../../types/IForYouForm";
import {SubmitHandlerType} from "../../types/SubmitHandlerType";
import {ForYouModalButton} from "../modal_parts/ForYouModalButton";

interface IProps {
    submitHandler: SubmitHandlerType;
    onNextStep: () => void;
    onChange?: (name: string, value: ForYouFormValuesType) => void;
}

export const ForYouCriteriaForm = (props: IProps) => {
    const mainRegion = useAppSelector((state) => state.forYouModal.mainRegionName);
    const dispatch = useAppDispatch();
    const budgetFieldsNames = {
        radio: `forYou_${BudgetFieldsNames.RADIO}`,
        credit: `forYou_${BudgetFieldsNames.CREDIT}`,
        total: `forYou_${BudgetFieldsNames.TOTAL}`
    };
    const {isMobile} = useUserDevice();
    const rooms = useWatch({name: "rooms"});
    const area = useWatch({name: "area"});
    const budget = useWatch({name: budgetFieldsNames.total});
    const instalment = useWatch({name: budgetFieldsNames.credit});
    const radioWatcher = useWatch({name: budgetFieldsNames.total});
    const maxArea = 300;
    const {maxPrice} = usePriceRanges();

    useEffect(() => {
        ForYouFormDisplayGtmEvent({event: ForYouEventType.CRITERIA, action: ForYouDisplayActions.OPEN, region: mainRegion});
    }, []);

    const onSubmit = () => {
        const roomsString = rooms.lower === rooms.upper ? rooms.lower.toString() : `${rooms.lower} - ${rooms.upper}`;
        const areaString = `${area.lower} - ${area.upper}`;
        const budgetString = radioWatcher === "total" ? budget.toString() : "";
        const instalmentString = radioWatcher === "monthly" ? instalment.toString() : "";
        dispatch(setForYouCriteria({rooms, area, ...(radioWatcher === "total" ? {budget} : {instalment})}));
        ForYouCriteriaGtmEvent({rooms: roomsString, area: areaString, budget: budgetString, instalment: instalmentString});
        props.onNextStep();
    };

    const setValue = (fieldName: string, value: IRange<number | "">) => {
        props.onChange?.(fieldName, value);
    };

    return (
        <form onSubmit={props.submitHandler(onSubmit)} css={formStyle}>
            <div css={filedWrapper}>
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Pokoje
                </Text>

                <SearchFiltersRooms toggleDropdown={() => null} clearField={() => null} name="rooms" value={rooms} showFooter={false} onChange={setValue} />
            </div>

            <div css={filedWrapper}>
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Powierzchnia mieszkania
                </Text>

                <SliderWithRangeControlled
                    name="area"
                    min={0}
                    max={maxArea}
                    step={1}
                    inputsRightElement={
                        <span>
                            m<sup>2</sup>
                        </span>
                    }
                />
            </div>

            <div css={filedWrapper}>
                <Text variant="body_copy_1" color={getThemeVariable("colors.gray.700")}>
                    Budżet
                </Text>

                <FilterBudget
                    radioGroupClassName="radioGroupStyles"
                    radioClassName="radiosStyles"
                    inputVariant={isMobile ? "column" : "row"}
                    fieldNames={budgetFieldsNames}
                    maxPrice={maxPrice}
                />
            </div>

            <ForYouModalButton isDisabled={area.lower > area.upper || area.upper < area.lower || area.upper > maxArea} showStep />
        </form>
    );
};

const formStyle = css`
    width: 100%;
    background-color: #fff;
    ${p(3, 1.5, 0, 1.5)};

    .radiosStyles {
        flex: 0;
        min-width: 160px;
    }

    .radioGroupStyles {
        ${mb(0)};

        @media (min-width: ${getThemeBreakpoint().md}) {
            ${mb(2)};
        }
    }

    @media (min-width: ${getThemeBreakpoint().md}) {
        ${p(4, 5, 4, 5)};
        height: 100%;
        background-color: ${getThemeVariable("colors.gray.100")};
    }

    .slider-with-range-slider-wrapper {
        flex: 1;
        width: 100%;
    }

    .slider-with-range-range-wrapper {
        flex: 1;
        width: 100%;

        @media (min-width: 1024px) {
            max-width: 40%;
        }
    }
`;

const filedWrapper = css`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: ${calculateRemSize(1)};
    ${mb(5)};
`;
